export enum EmailType {
  CandidateRefRequest = 'CandidateRefRequest',
  CandidateRefRequestReminder = 'CandidateRefRequestReminder',
  ReferenceRefRequest= 'ReferenceRefRequest'
}
